import { render } from "./HeaderGame.vue?vue&type=template&id=a8ad6798"
import script from "./HeaderGame.vue?vue&type=script&lang=js"
export * from "./HeaderGame.vue?vue&type=script&lang=js"

import "./HeaderGame.vue?vue&type=style&index=0&id=a8ad6798&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__